<template>
  <div>
    <search-agent-pre-order @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button type="primary" @click="showNewModal(0)" v-if="isShowMenu('agent_pre_order_items/new')">新增</a-button>
      </a-space>
    </div>

    <a-spin :spinning="loading">
      <div v-if="isDataExist">
        <div
          v-for="order in data"
          :key="order.id"
        >
          <div class="simiot-card-box" style="margin-bottom: 20px">
            <a-row class="order-header">
              <a-col :span="16">
                <a-row>
                  <a-col :span="8">
                    <div v-if="isShowMenu('agent_pre_orders/show')">
                      <a @click="showInfoModal(order.id)">{{ order.order_no }}</a>
                    </div>
                    <div v-else>
                      {{ order.order_no }}
                    </div>
                  </a-col>

                  <a-col :span="8" class="agent-name">
                    {{ order.agent_name }}
                  </a-col>

                  <a-col :span="4">
                    {{ order.sales_full_names }}
                  </a-col>
                </a-row>

                <a-row>
                  <a-col :span="8">
                    {{ order.created_at }}
                  </a-col>
                  <a-col :span="4">
                    {{ order.order_type }}
                  </a-col>
                  <a-col :span="4">
                    {{ order.status }}
                  </a-col>
                  <a-col :span="8">
                    {{ order.product_count }}
                    <span v-if="order.express_no" class="express-no">{{ order.express_no }}</span>
                  </a-col>
                </a-row>
              </a-col>

              <a-col :span="8">
                <div class="simiot-table-operation-buttons">
                  <a-space>
                    <a-button
                      type="primary"
                      v-if="order.status_slug === 'processing' && isShowMenu('agent_pre_order_items/new')"
                      @click="showNewModal(order.id)"
                      @completed="fetchData"
                    >添加</a-button>
                  </a-space>
                </div>
              </a-col>
            </a-row>

            <agent-pre-order-items-list
              :items="order.agent_pre_order_items"
              :loading="loading"
              @completed="fetchData"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <a-empty />
      </div>
    </a-spin>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <!-- 新增预制订单模态框 -->
    <new-agent-pre-order-item
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      :id="newingId"
      @completed="fetchData"
    />

    <!-- 编辑预制订模态框 -->
    <edit-agent-pre-order-item
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :id="editingId"
      @completed="fetchData"
    />

    <!-- 详情模态框 -->
    <show-agent-pre-order
      v-if="isShowInfoModal"
      :visible.sync="isShowInfoModal"
      :id="showingId"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { findAgentPreOrders } from '@/api/agent_pre_order'
import AgentPreOrderItemsList from '@/views/agent_pre_order_items/index'
import SearchAgentPreOrder from '@/views/agent_pre_orders/Search'
import { hasPermission } from '@/utils/permission'

export default {
  name: 'AgentPreOrderList',
  components: {
    Pagination,
    AgentPreOrderItemsList,
    SearchAgentPreOrder,
    NewAgentPreOrderItem: () => import('@/views/agent_pre_order_items/New'),
    EditAgentPreOrderItem: () => import('@/views/agent_pre_order_items/Edit'),
    ShowAgentPreOrder: () => import('@/views/agent_pre_orders/Show')
  },
  data() {
    return {
      data: [],
      loading: true,
      newingId: 0, // 正在新增项目的订单id
      isShowNewModal: false,
      isShowEditModal: false,
      showingId: 0, // 正在显示详情的订单id
      isShowInfoModal: false,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  created() {
    if (this.$store.getters.userRole === 'purchaser') {
      this.query = Object.assign({},
        { item_status: ['check_resource_all', 'check_resource_party_of'] })
    } else if (this.$store.getters.userRole === 'storekeeper') {
      this.query = Object.assign({},
        { item_status: ['check_store'] })
    }

    this.fetchData()
  },
  computed: {
    columns() {
      return [
        {
          title: '项目编号',
          dataIndex: 'id'
        }
      ]
    },
    agentId() {
      return this.$store.getters.userAgentId
    },
    isDataExist() {
      return this.data.length > 0
    }
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showInfoModal(recordId) {
      this.showingId = recordId
      this.isShowInfoModal = true
    },

    showNewModal(recordId) {
      this.newingId = recordId
      this.isShowNewModal = true
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findAgentPreOrders(Object.assign(
        { agent_id: this.agentId }, this.query)
      ).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.order-header {
  margin-bottom: 5px;
  color: #8b8b8b;

  .agent-name {
    color: #5d5d5d;
  }

  .express-no {
    margin-left: 8px;
  }
}
</style>
